<template>
  <div class="irp-opportunities-tab" data-testid="irp-opportunities-tab">
    <h3 class="irp-opportunities-tab__heading">Opportunity information</h3>
    <IRPFieldGrid
      v-for="(opportunity, index) in ownOpportunities"
      :key="`opportunity_${index}`"
      :fields="opportunity.fields"
    />

    <IRPPartnerDataSection
      :key="individualRecordStore.recordKey"
      section="opportunities"
    >
      <template #default="{ partner }">
        <IRPFieldGrid
          v-for="(opportunity, index) in partner.opportunities.items"
          :key="`partner_opportunity_${index}`"
          :fields="opportunity.fields"
        />
      </template>
    </IRPPartnerDataSection>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useIndividualRecordStore } from '@/stores';
import type { RecordCollectionType } from '@/types/individual_record';

import IRPFieldGrid from './IRPFieldGrid.vue';
import IRPPartnerDataSection from './IRPPartnerDataSection.vue';

const individualRecordStore = useIndividualRecordStore();

const ownOpportunities = computed(
  () =>
    (
      individualRecordStore.opportunities?.own?.opportunities as
        | RecordCollectionType
        | undefined
    )?.items ?? [],
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-opportunities-tab {
  @apply flex flex-col gap-16;
}

.irp-opportunities-tab__heading {
  @apply text-base font-bold text-neutral-text-strong;
}
</style>
